export default {
  'Welcome!': 'Witaj!',
  'Joint ID': 'Numer ID mufy',
  'Joint Log': 'Log mufy',
  'Home': 'Nazwa',
  'ID': 'ID',
  'Alarm': 'Alarm',
  'temps': 'temp',
  'Temperature': 'Temperatury',
  'Joints': 'Mufy',
  'Current Report': 'Bieżący Raport',
  'Current Equipment': 'Bieżąca Zgrzewarka',
  'Joints welded over time': 'Mufa zgrzewana ponad limit czasowy',
  'Equipment': 'Zgrzewarka',
  ' Equipment': ' Zgrzewarka',
  'Timestamp': 'Znacznik czasu',
  'timestamp': 'znacznik czasu',
  'Welds': 'Zgrzewy',
  'Actions': 'Działania',
  'Report Preview': 'Pogląd Raportu',
  'Page:': 'Strona',
  'Filters': 'Filtry',
  'This Week': 'Bieżący Tydzień',
  'This Month': 'Bieżący Miesiąc',
  'This Year': 'Bieżący Rok',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Styczń_Luty_Marzec_Kwiecień_Maj_Czerwiec_Lipiec_Sierpień_Wrzesień_Październik_Listopad_Grudzień',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Sty_Lut_Mar_KWi_Maj_Cze_Lip_Sie_Wrz_Paź_Lis_GRU',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Pon_Wt_Śr_Czw_Pt_So_Nie',
  'Previous': 'Poprzedni',
  'Reloading data..': 'Reloading danych',
  'Data reloaded': 'Dane załadowane',
  'Add to report': 'Dodaj do raportu',
  'Next': 'Następny',
  'Rental Start Date': 'Rozpoczęcie wynajmu',
  'Rental End Date': 'Zakończenie wynajmu',
  'Map': 'Mapa',
  'Password': 'Hasło',
  'The password is required!': 'Hasło jest wymagane',
  'Password must be at least {1} characters': 'Hasło musi się składać przynajmniej z jednego znaku',
  'Create User': 'Utwórz Użytkownika',
  'First Name': 'Imię',
  'Last Name': 'Nazwisko',
  'E-mail': 'E-mail',
  'User list': 'Lista użytkowników',
  'Create new user': 'Utwórz nowego użytkownika',
  'Edit': 'Edytuj',
  'Delete': 'Usuń',
  'User Profile': 'Profil Użytkownika',
  'Save': 'Zapisz',
  'User Companies': 'Firmy użytkownika',
  'Select companies': 'Wybierz firmy',
  'Save Companies': 'Zapisz firmy',
  'Welding Report': 'Raport Zgrzewania',
  'Welding Machine': 'Zgrzewarka',
  'Welding Machines': 'Zgrzewarki',
  'Created by:': 'Stworzony przez',
  'Company:': 'Firma',
  'of': 'z',
  'Remove': 'Usuń',
  'Clear Report': 'Wyczyść Raport',
  'Preview Report': 'Podejrzyj Raport',
  'Print Report': 'Wydrukuj Raport',
  'Are you sure?': 'Czy jesteś pewny',
  'Sign In to your account': 'Zaloguj się na własne konto',
  'Email': 'Email',
  'Forgot password?': 'Zapomniałeś hasła?',
  'Logging in..': 'Logowanie..',
  'Access Denied': 'Odmowa dostępu',
  'Map (Only shows welding machines)': 'Mapa (tylko lokalizacja zgrzewarek)',
  'All': 'Wszystko',
  'Machine ID': 'Numer Zgrzewarki',
  'icon-110': 'icon-110',
  'Ongoing': 'W trakcie',
  'Historical equipment rentals': 'Historia wynajmu sprzętu',
  'On': 'Włącz',
  'Off': 'Wyłącz',
  'Equipment ID (If applicable)': 'ID sprzętu (jeśli znajduje zastosowanie)',
  'Description': 'Opis',
  'Write a description of what happened..': 'Opisz co się stało',
  'Alert customer to send back equipment': 'Poinformuj klienta o konieczności zwrotu sprzętu',
  'Date': 'Data',
  'Reason': 'Powód',
  'Created by': 'Utworzony przez',
  'Customer Log': 'Log klienta',
  'Create Log Entry': 'Stwórz wpis do log-a',
  'Support - Phone': 'Wsparcie - Telefon',
  'Support - E-mail': 'Wsparcie - E-mail',
  'Sales - Phone': 'Sprzedaż - telefon',
  'Sales Activity - Campaign, Email etc.': 'Działalność Sprzedażowa - Kampania, E-mail etc.',
  'Slug': 'Slug',
  'Subject': 'Temat',
  'Email Templates': 'Wzór emaila',
  'Revision Date': 'Data sprawdzenia',
  'CPU': 'CPU',
  'Filename 1': 'Nazwapliku1',
  'Filename 2': 'Nazwapliku2',
  'Revisions': 'Sprawdzenia',
  'Revision': 'Sprawdzenie',
  'Upload new revision': 'Dodaj nowe sprawdzenie',
  'Equipment ID': 'ID Sprzętu',
  '# CPUs': '# CPUs',
  'Create Equipment Specification': 'Stwórz specyfikację sprzętu',
  'Display': 'Wyświetlacz',
  'Styrkort': 'Styrkort',
  'Latest rev CPU 1': 'Latest rev CPU 1',
  'Latest rev CPU 2': 'Latest rev CPU 1',
  'Equipment Specifications': 'Specyfikacja sprzętu',
  'Create specification': 'Stwórz specyfikację',
  'Old': 'Stara',
  'New': 'Nowa',
  'Create Update Entry': 'Stwórz Wpis Aktualizacyjny',
  'Update Queue': 'Odśwież kolejkę',
  'Create update entry': 'Stwórz wpis aktualizacyjny',
  '[Welcome Title]': 'Witaj',
  '[Welcome Body]': 'Ten portal udostępnia informacje na temat muf wykonanych w Twojej firmie. Do nawigacji użyj menu po prawej stronie.',
  'Number of joints': 'Liczba muf',
  'Dimension': 'Średnica',
  'Select a Machine ID': 'Wybierz numer zgrzewarki',
  'Choose the equipment related to your message (optional)': 'Wybierz sprzęt powiązany z Twoją wiadomością (opcja)',
  '-- Nothing Selected --': '--Nic nie wybrano--',
  'Message': 'Wiadomość',
  'Write your message here': 'Tutaj napisz swoją wiadomość',
  'I want to send back the equipment': 'Chcę zwrócić sprzęt',
  'Contact Support': 'Skontaktuj się z Supportem',
  'Send message': 'Wyślij wiadomość ',
  'Login': 'Zaloguj',
  'Logout': 'Wyloguj',
  'Users': 'Użytkownicy',
  'Firmware Revisions': 'Firmware Revisions',
  'Equipment Spec.': 'Specyfikacja Sprzętu',
  'Remote Update': 'Update zdalny',
  'Dashboard': 'Panel',
  'Current': 'Obecny',
  'Historical': 'Historyczny',
  'Weld Report': 'Raport Zgrzewu',
  'Weld Report for ': 'Raport Zgrzewu dla',
  'Support': 'Wsparcie',
  'joint_time_a': 'mufa_czas_a',
  'u_mains': 'napięcie',
  'mode': 'mode',
  'alarm': 'alarm',
  'channel': 'kanał',
  'dimension': 'średnica',
  'name': 'nazwa',
  'Report Name:': 'Nazwa Raportu',
  'Comment': 'Komentarz',
  'Joint Comment': 'Komentarz',
  'Write a report name.. (optional)': 'Wpisz nazwę raportu (opcjonalnie)',
  'Report name:': 'Nazwa Raportu',
  'Add all to report': 'Dodaj wszystko do raportu',
  'Per page': 'Na stronę',
  'ALARM-0': 'ALARM-0',
  'ALARM-1': 'ALARM-1',
  'ALARM-2': 'ALARM-2',
  'ALARM-4': 'ALARM-4',
  'ALARM-8': 'ALARM-8',
  'ALARM-16': 'ALARM-16',
  'ALARM-32': 'ALARM-32',
  'ALARM-64': 'ALARM-64',
  'ALARM-128': 'ALARM-128',
  'TIME-min': 'CZAS-min',
  'TIME-sec': 'CZAS-sek',
  'Seconds': 'Sekundy',
  'Minutes': 'Minuty',
  'Select a Dimension': 'Wybierz Średnicę'
}



// WEBPACK FOOTER //
// ./src/translations/pl.js